
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import Vue from "vue";

export default Vue.extend({
	props: {
		title: {
			type: [String, Object as () => {toString():string}],
			required: true
		},
		subtitle: {
			type: [String, Object as () => {toString():string}]
		},
		deletable: Boolean,
		maxWidth: [String, Number]
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		save() {
			this.$emit("save");
		},
		deleteEvent() {
			this.$emit("delete");
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}

});
